import React from 'react'
import { useTheme } from '@material-ui/core/styles'

// title for within content
const CustomText = props => {
  const theme = useTheme()
  const { text, style } = props

  const styles = {
    titleLarge: {
      textAlign: props.align ? props.align : 'left',
      fontSize: '20px',
      margin: props.margin ? props.margin : '0px',
      color: '#03A9F4',
      fontWeight: 'normal'
    },
    titleMedium: {
      textAlign: props.align ? props.align : 'left',
      fontSize: '12px',
      color: theme.palette.secondary.dark,
      fontWeight: 'bold'
    },
    subtitle: {
      textAlign: props.align ? props.align : 'left',
      fontSize: '11px',
      color: theme.palette.secondary.main
      // fontWeight: 'bold'
    },
    cardMedium: {
      fontSize: '18px',
    },
    cardAmount: {
      fontSize: '32px',
      fontWeight: 'bold',
      marginTop: 8,
      marginLeft: 16,
    },
    totalCount: {
      fontSize: '32px',
      color: '#455A64',
      textAlign: 'center',
    },
    totalNumber: {
      fontSize: '48px',
      color: '#303F9F',
      textAlign: 'center'
    }
  }

  return (
    <div style={styles[style]}>
      {text}
      {props.children}
    </div>
  )
}

export default CustomText
